import axios from '../axios';
import { checkResponse } from '../utils';
import { apiV1 } from '../utils/constant';
/**
 * @function getSpecialSetting
 * @desc 获取企业定制配置列表
 * @param {String} companyId 企业id
 * @returns {Object}
 */
function getSpecialSetting(companyId) {
  return axios
    .get(`${apiV1}/sw/specialSetting/list?companyId=${companyId}&service=2`)
    .then(checkResponse);
}
/**
 * @function getSpecialSettingkeys
 * @desc 企业定制配置详细（指定配置键值）
 * @param {String} companyId 企业id
 * @param {Object} keys 配置项
 * @returns {Object}
 */
function getSpecialSettingkeys(companyId, keys) {
  return axios
    .get(`${apiV1}/sw/specialSetting/info/keys?companyId=${companyId}&keys=${keys}&service=2`)
    .then(checkResponse);
}
/**
 * @function checkIsSpecialCompany
 * @desc 是否是定制企业
 * @param {String} companyId 企业id
 * @returns {Object}
 */
function checkIsSpecialCompany(companyId) {
  return axios.get(`${apiV1}/sw/company/effect?companyId=${companyId}`).then(checkResponse);
}

/**
 * 拉萨创城定制-超管或根目录
 * @param {*} companyId
 * @returns
 */
function checkIsAdminBoot(companyId) {
  return axios.get(`${apiV1}/sw/customer/boot/admin?companyId=${companyId}`).then(checkResponse);
}
/**
 * 根据企业获取定制企业详细
 * @param {*} companyId
 * @returns
 */
function customCompanyInfo(companyId) {
  return axios
    .get(`${apiV1}/sw/customCompany/info/company?companyId=${companyId}`)
    .then(checkResponse);
}
/**
 * 根据当前企业id
 * @param {*} companyId
 * @returns
 */
function getCurrentCompanyId() {
  return axios.get(`${apiV1}/sw/customer/current/company`).then(checkResponse);
}
export {
  getSpecialSetting,
  getSpecialSettingkeys,
  checkIsSpecialCompany,
  checkIsAdminBoot,
  customCompanyInfo,
  getCurrentCompanyId,
};
